import React, { PureComponent } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import { ListItemIcon } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import withStyles from '@mui/styles/withStyles';
import { withTranslation } from 'react-i18next';

class LanguagesList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isDropdownOpen: false,
    };
  }

  handleDropdownToggle = () => {
    this.setState({
      isDropdownOpen: !this.state.isDropdownOpen,
    });
  };

  handleChange = event => {
    const { i18n } = this.props;
    i18n.changeLanguage(event.currentTarget.getAttribute('data-lng'));
  };

  render() {
    const { classes, t } = this.props;
    return (
      <>
        <ListItemButton onClick={this.handleDropdownToggle}>
          <ListItemIcon>
            <LanguageIcon />
          </ListItemIcon>
          <ListItemText>{t('Language')}</ListItemText>
          {this.state.isDropdownOpen ? (
            <ExpandLess className={classes.expandIcon} />
          ) : (
            <ExpandMore className={classes.expandIcon} />
          )}
        </ListItemButton>
        <Collapse in={this.state.isDropdownOpen}>
          <List dense disablePadding>
            <ListItemButton
              selected={false}
              onClick={this.handleChange}
              data-lng="en"
            >
              <ListItemText inset>English</ListItemText>
            </ListItemButton>
            <ListItemButton
              selected={false}
              onClick={this.handleChange}
              data-lng="ru"
            >
              <ListItemText inset>Русский</ListItemText>
            </ListItemButton>
          </List>
        </Collapse>
      </>
    );
  }
}

const styles = theme => ({
  expandIcon: {
    color: theme.palette.text.secondary,
  },
});

export default withTranslation()(withStyles(styles)(LanguagesList));
